import React, { useState } from "react";
import "./App.css";

const App = () => {
  const screenshotsTP = [
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/FN4/1.png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/FN4/7.png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/FN4/8.png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/FN4/9.png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/EU6/10+(1).png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/FN4/17.png",

  ];

  const screenshotsEU = [
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/EU5/1.png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/EU6/6.png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/EU6/7.png",
    "https://sinewavedb.s3.ap-south-1.amazonaws.com/Mobile+Screenshot/EU6/8.png",
  
  ];

  const [indexTP, setIndexTP] = useState(0);
  const [indexEU, setIndexEU] = useState(0);

  const handleNextTP = () => {
    if (indexTP < screenshotsTP.length - 1) {
      setIndexTP(indexTP + 1);
    }
  };

  const handlePrevTP = () => {
    if (indexTP > 0) {
      setIndexTP(indexTP - 1);
    }
  };

  const handleNextEU = () => {
    if (indexEU < screenshotsEU.length - 1) {
      setIndexEU(indexEU + 1);
    }
  };

  const handlePrevEU = () => {
    if (indexEU > 0) {
      setIndexEU(indexEU - 1);
    }
  };

  return (
    <div className="container">
      <div className="screens">
        <div className="screen">
          <h2>TP Login</h2>
          <div className="mobile-frame">
            <img src={screenshotsTP[indexTP]} alt={`TP Login ${indexTP + 1}`} className="screenshot" />
          </div>
          <div className="controls">
            <button onClick={handlePrevTP} disabled={indexTP === 0}>Previous</button>
            <button onClick={handleNextTP} disabled={indexTP === screenshotsTP.length - 1}>Next</button>
          </div>
        </div>
        <div className="screen">
          <h2>EU Login</h2>
          <div className="mobile-frame">
            <img src={screenshotsEU[indexEU]} alt={`EU Login ${indexEU + 1}`} className="screenshot" />
          </div>
          <div className="controls">
            <button onClick={handlePrevEU} disabled={indexEU === 0}>Previous</button>
            <button onClick={handleNextEU} disabled={indexEU === screenshotsEU.length - 1}>Next</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
